/**
 * @author: leroy
 * @date: 2021/8/21 09:54
 * @description：首页
 */
import { Carousel } from 'antd';
import styles from '@/styles/pages/home.module.scss';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import type { CarouselRef } from 'antd/lib/carousel';
import Url from '@/utils/url';
import classNames from 'classnames';
import { handleUrl } from '@/utils/util';
import Layout from '@/layout';
import type { NextPage } from 'next';
import { useStore } from '@/store/store';
import { useRouter } from 'next/router';
import ConfirmPhoneModal from '@/components/ConfirmPhoneModal/ConfirmPhoneModal';
import Image from 'next/image';

const subjectList = [
  '单项选择题',
  '多项选择题',
  '不定项选择题',
  '判断题',
  '填空题',
  '听力题',
  '问答题',
  '编程问答题',
  '阅读题',
  '编程题',
];

const monitorList = [
  { title: '阅读考前须知', info: '注意考试时间、题目种类、题目数量题' },
  {
    title: '音视频调试',
    info: '开启pc端的摄像头监控和麦克风监控，防止考试过程中考生与他人交头接耳。',
  },
  {
    title: '屏幕共享',
    info: '监控考生的pc端屏幕，防止考生使用浏览器或第三方软件作弊。',
  },
  { title: '手机监控', info: '将手机摄像头作为第二视角摄像头，防止考生使用手机。' },
  { title: '考生签名', info: '签署诚信承诺书，海投云笔试将永久记录考生的答题记录和作弊记录。' },
];

const fourteen = [
  { title: '人脸识别', info: '自研的人脸识别系统，识别准确性高，识别速度快。' },
  { title: '视频监控（第一视角）', info: '通过电脑摄像头设备实时监控，结合AI识别作弊风险。' },
  { title: '视频监控（第二视角）', info: '通过手机摄像头设备实时监控，扩大监控范围。' },
  { title: '语音监控', info: '结合慧声AI系统，实时监控音频设备，避免他人协助。' },
  { title: '屏幕监控', info: '识别答题页的图文信息，监控异常内容和异常操作。' },
  { title: '切屏监控', info: '防止考生通过第三方软件或搜索引擎等获取答案。' },
  { title: '剪切板监控', info: '防止考生复制站外内容和已复制的文本信息。' },
  { title: '答题行为识别', info: '通过图文识别系统将考生所有的监控材料进行图像和文本识别' },
  { title: '手机锁定', info: '监控手机设备是否进行最小化、切屏、关闭等行为。' },
  { title: '实时监拍', info: '考试途中，一旦识别出异常风险，立刻监拍传至HR后台。' },
  { title: '问答题字节回放', info: '留存考生文本框的答题过程，以供HR查阅。' },
  { title: '代码字节回放', info: '留存考生编程框的答题过程，以供HR查阅。' },
  { title: '问答题查重', info: '将考生文本框输入内容比对全站信息，生成查重报告。' },
  { title: '代码查重', info: '将考生编程框输入内容比对全站信息，生成查重报告。' },
];

const tips = [
  '不定项选择题的正确答案可能为一个或者多个',
  '填空题若有填空顺序，请严格按照顺序填写答案',
  '在听力题答题过程中切题，会消耗听力次数',
  '编程问答题可使用代码编译框或文本输入框答题',
  '编程题请先选择需要编译的代码语言',
  '在做编程题时建议打开编程模式',
];

const imageUrl = Url.staticHost + '/image/home';

const Home: NextPage = () => {
  const sliderRef1 = useRef<CarouselRef>(null);
  const sliderRef2 = useRef<CarouselRef>(null);
  const sliderRef3 = useRef<CarouselRef>(null);
  const [activeBtn, setActiveBtn] = useState<number>();
  const [activeTab, setActiveTab] = useState();
  // const [mask, setMask] = useState(false);
  const router = useRouter();

  // useKeyPress(
  //   ['meta.shift'],
  //   () => {
  //     console.log('22', 22);
  //     setMask(true);
  //   },
  //   { exactMatch: true },
  // );

  // useEffect(() => {
  //   document.addEventListener('blur', () => {
  //     console.log('123', 123);

  //   });
  // }, []);

  const {
    userStore,
    userStore: { auth },
    homeStore: { fetchList, examList },
  } = useStore();

  useEffect(() => {
    if (examList?.exams.length) return;
    window.loginCallback = () => {
      fetchList({ auth: auth || '', page: 1, limit: 10 });
    };
    return () => {
      window.loginCallback = undefined;
    };
  }, [auth]);

  const changeSlider = (ref: CarouselRef, v) => {
    if (typeof v === 'string') {
      return v === 'prev' ? ref.prev() : ref.next();
    } else {
      ref.goTo(v);
    }
  };

  const examInfoBtnClick = (index: number) => {
    setActiveBtn(index);
    changeSlider(sliderRef2.current!, index);
  };

  const tabItemClick = (index) => {
    setActiveTab(index);
    changeSlider(sliderRef3.current!, index);
  };

  return (
    <Layout mode={1}>
      {/* <div
        style={{
          backgroundColor: 'white',
          position: 'fixed',
          zIndex: 99,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      /> */}

      <div className={styles.box}>
        <section className={styles.bannerBox}>
          <h1 className={styles.title}>海投在线笔试考场总览</h1>
          <p className={styles.titleText}>快速了解笔试题型，帮助你轻松通过考试</p>
          <div className={styles.btnBox}>
            <button
              className={styles.btn + ' btn_blue_hover'}
              onClick={() => {
                if (!auth) return userStore.setConfirmModalShow(true);
                router.push(
                  process.env.PROD
                    ? `/q85xaol5alW7vRE9/preview?subject=1`
                    : `/9r3Mmg2BKbMgapkn/preview?subject=1`,
                );
              }}
            >
              进入考场查看题型 →{' '}
            </button>
          </div>

          <div className={styles.sliderBox + ' center-wrapper'}>
            <div className={styles.left} onClick={() => changeSlider(sliderRef1.current!, 'prev')}>
              <img width={'22px'} src={Url.staticHost + '/image/home/leftArrow.png'} alt="" />
            </div>
            <div className={styles.right} onClick={() => changeSlider(sliderRef1.current!, 'next')}>
              <img width={'22px'} src={Url.staticHost + '/image/home/leftArrow.png'} alt="" />
            </div>
            <div className={styles.slider}>
              <Carousel ref={sliderRef1} dots={false} autoplay>
                {[...Array(3)].map((_, index) => (
                  <div key={_}>
                    <Image
                      src={`${imageUrl}/bannerImage/${index + 1}.1.png`}
                      width={1030}
                      height={525}
                      alt=""
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </section>

        {/* {examList?.exams.length !== 0 && (
          <section className={styles.myBsBox}>
            <h2 className={styles.title}>我的笔试</h2>
            <div className={styles.titleIcon + ' center-wrapper'}>
              <img src={Url.staticHost + '/image/home/titleIcon.png'} alt="" />
            </div>
            <div className={styles.examList + ' center-wrapper'}>
              {examList?.exams
                ?.filter((item) => item.type !== 0)
                .map((item) => (
                  <a
                    className={styles.examItem}
                    key={item.id}
                    onClick={() => {
                      if (!auth) return userStore.setConfirmModalShow(true);
                      if (item.userData?.finish_time) return router.push(`/${item.id}/submit`);
                      router.push(`/${item.id}`);
                    }}
                  >
                    <img
                      src={handleUrl(item.banner)}
                      alt=""
                      width="260px"
                      height="160px"
                      style={{ borderRadius: 6 }}
                    />
                    <div className={styles.info}>
                      <div>
                        <h1>{item.name}</h1>
                        <p>考试对象：{item.category}</p>
                      </div>
                      <p className={styles.company}>
                        <img
                          src={handleUrl(
                            item.info
                              ? item.info.logoUrl
                              : item.logo ||
                                  'http://uploads.01.haitou.cc/company/logo/17/33017_bb60.png?v=1478657876',
                          )}
                          alt=""
                        />
                        <span>
                          {[paperTypeEnum.exam, paperTypeEnum.longTime].includes(item.type)
                            ? item.info?.company
                            : item.origin}
                        </span>
                      </p>
                    </div>
                    <span
                      className={classNames(styles.goBtn)}
                      style={{
                        background: item.userData?.finish_time ? 'var(--btnGrey)' : undefined,
                      }}
                    >
                      {item.userData?.finish_time ? '已结束' : '进入笔试'}
                    </span>
                  </a>
                ))}
            </div>
          </section>
        )} */}

        <section className={classNames(styles.examInfoBox)}>
          <h2 className={styles.title}>在线笔试简介</h2>
          <div className={styles.titleIcon + ' center-wrapper'}>
            <img src={Url.staticHost + '/image/home/titleIcon.png'} alt="" />
          </div>
          <div className={styles.showBox + ' center-wrapper'}>
            <div>
              <div className={styles.showTitle}>
                <span className={styles.dot} />
                <span className={styles.dot} />
                十大题型答题演示
              </div>
              <p className={styles.message}>
                海投在线笔试共有五大题型：选择题、填空题、判断题、问答题、编程题。
              </p>
              <p className={styles.message}>
                其中选择题还分为：单项选择题、多选题、不定项选择题；
                问答题分为：一般问答题、编程问答题。
              </p>
              <div className={styles.btnBox}>
                {subjectList.map((item, index) => (
                  <button
                    className={classNames(styles.btn, { [styles.btnActive]: index === activeBtn })}
                    key={item}
                    onClick={() => examInfoBtnClick(index)}
                  >
                    {item}
                  </button>
                ))}
              </div>
              <Carousel
                ref={sliderRef2}
                dots={false}
                autoplay
                className={styles.warningBox}
                effect="fade"
              >
                {tips.map((_) => (
                  <div key={_}>{_}</div>
                ))}
              </Carousel>
            </div>
            <div className={styles.right}>
              <div className={styles.infoSlider}>
                <Carousel ref={sliderRef2} dots={false}>
                  {[...Array(10)].map((_, index) => (
                    <div key={_}>
                      <img
                        src={imageUrl + `/allSubjects/${index + 1}.1.png`}
                        width="100%"
                        height={415}
                        alt=""
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.monitorBox}>
          <div className={'center-wrapper flex'}>
            <div className={styles.leftBox}>
              {monitorList.map((item, index) => (
                <div
                  className={classNames(styles.tabItem, {
                    [styles.tabItemActive]: index === activeTab,
                  })}
                  key={item.title}
                  onClick={() => tabItemClick(index)}
                >
                  <strong>{index + 1 + '. ' + item.title}</strong>
                  <p>{item.info}</p>
                </div>
              ))}
            </div>
            <div className={styles.rightBox}>
              <div className={styles.monitorTitle}>
                <span className={styles.dot} />
                <span className={styles.dot} />
                答题前设备调试
              </div>
              <p className={styles.monitorBoxInfo}>
                海投云笔试答题前的设备调试共分为五步：阅读考前须知、音视频调试、屏幕共享、
              </p>
              <p className={styles.monitorBoxInfo}>手机监控、考生签名</p>
              <div className={styles.monitorSliderBox}>
                <Carousel ref={sliderRef3} dots={false}>
                  {[...Array(5)].map((_, index) => (
                    <div key={_} style={{ height: 420 }}>
                      <img
                        src={imageUrl + `/beforeExam/${index + 1}.png`}
                        width="100%"
                        height="100%"
                        alt=""
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.allMonitorBox}>
          <div className={styles.allMonitorTitle}>
            <span className={styles.dot} />
            <span className={styles.dot} />
            海投云笔试共有14种监控手段
          </div>
          <p className={styles.allMonitorTitleInfo + ' center-wrapper'}>
            人脸识别、视频监控、第二视角监控、语音监控、手机锁定、屏幕监控、屏幕监拍、切屏监控、剪切板监控、答题过程监控、实时监控、代码字节回放、问答题字节回放、代码全站查重、问答题全站查重
          </p>

          <div className={styles.monitorListBox}>
            {fourteen.map(({ title, info }, index) => (
              <div className={styles.monitorItem} key={title}>
                <div>
                  <strong>
                    {index + 1 < 10 ? `0${index + 1}. ` : `${index + 1}. `}
                    {title}
                  </strong>
                  <p>{info}</p>
                </div>
                <div className={styles.icon_box}>
                  <img
                    src={handleUrl(Url.staticHost + `/image/home/bottomIcon/${index + 1}.png`)}
                    alt=""
                  />
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <ConfirmPhoneModal onConfirm={() => {}} />
    </Layout>
  );
};

export async function getStaticProps() {
  // By returning { props: { posts } }, the Blog component
  // will receive `posts` as a prop at build time
  return {
    props: {},
  };
}

export default observer(Home);
